import { createListLoadingReducer } from './utils';
import { ArticleType } from '@/types';


export default createListLoadingReducer<ArticleType>('ARTICLE_TYPES');
